export enum RoutePDFOptions {
  PDF_ROUTE = 'PDF_ROUTE',
  PDF_TICKETS = 'PDF_TICKETS',
  PDF_ROUTE_WITH_TICKETS = 'PDF_ROUTE_WITH_TICKETS',
}
